import { render, staticRenderFns } from "./tray.vue?vue&type=template&id=ee53d12a&"
import script from "./tray.ts?vue&type=script&lang=ts&"
export * from "./tray.ts?vue&type=script&lang=ts&"
import style0 from "./tray.vue?vue&type=style&index=0&id=ee53d12a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports